import {ScForm} from '@/models/ScForm';
import {serviceManager} from "@/components/business/crud/service/ServiceManager";
import {ModelWidgetSchema} from "@/components/business/crud/interface/ModelWidgetSchema";
import {app} from "@/models/App";
import {SearchWidgetContainer} from "@/components/business/crud/widgets/SearchWidgetContainer";
import _ from "lodash";

export function createSearchService(moduleName: string, controllerName: string) {
    const Clazz = serviceManager.getService(
        moduleName,
        controllerName,
        'search',
        CrudSearchService
    );
    return new Clazz(
        moduleName,
        controllerName,
    );
}

export class CrudSearchService {
    protected schema: ModelWidgetSchema;
    protected widgetContainer: SearchWidgetContainer;
    protected form: ScForm;

    constructor(
        protected moduleName: string,
        protected controllerName: string,
    ) {
        this.schema = app.data.widgetMap[moduleName][controllerName];
        this.widgetContainer = new SearchWidgetContainer();
        this.form = new ScForm();
    }

    /**
     * 设置只读字段
     * 将值设置为表单默认值，并将字段设置为show
     * @param param
     */
    setReadonlyFields(param?: Record<string, unknown>) {
        if (!param) {
            return;
        }
        for (const field of Object.values(this.widgetContainer.fields.value)) {
            if (Reflect.has(param, field.propName)) {
                this.form.origin.value[field.propName] = param[field.propName];
                this.form.data.value[field.propName] = param[field.propName];
                if (field.statusSettings.edit === 'edit') {
                    field.statusSettings.edit = 'show';
                }
            }
        }
    }

    async init() {
        Object.entries(this.schema.widgets).map(([propName, widget]) => {
            if (widget.search) {
                this.widgetContainer.addField(propName, widget.title, widget.search,
                    {groupName: widget.groupName, desc: widget.desc});
            }
        });
        await this.form.init();
    }

    use() {
        return {
            getCondition:this.getCondition.bind(this),
            form: this.form,
            groups: this.widgetContainer.groups,
        };
    }

    protected getCondition() {
       return _.cloneDeep(this.processSubmitData(this.form.data.value));
    }

    protected processSubmitData(formData: Record<string, unknown>) {
        const submitData: Record<string, unknown> = {};
        for (const field of Object.values(this.widgetContainer.fields.value)) {
            const value = formData[field.propName];
            const widget = field.widget
            switch (widget.name) {
                case "selectRemote": {
                    if (value instanceof Array && value.length > 0) {
                        _.set(submitData, [field.propName, widget.valueFieldName, "$in"], value.map(i => i[widget.valueFieldName]))
                    }
                    break;
                }
                default:
                    submitData[field.propName] = formData[field.propName];
            }
        }
        return submitData;
    }

}
